// extracted by mini-css-extract-plugin
export default {"sliderButton":"components-SliderDots-themes-default-styles__sliderButton--A1CwK","active":"components-SliderDots-themes-default-styles__active--xzY3p"};